/**
 * Role badge for team members. Mirrors SiteStatusBadge — display-only,
 * all data passed via props.
 */
export default function TeamRoleBadge({ role }) {
  const r = (role || '').toLowerCase();
  const isAdminRole = r === 'admin';
  return (
    <span className={`team-role-badge ${isAdminRole ? 'team-role-badge-admin' : 'team-role-badge-technician'}`}>
      {isAdminRole ? 'Admin' : 'Technician'}
    </span>
  );
}
